import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';

import { getUserEmail } from '../../utils/auth';

import './Security.scss';

export default function Security() {
  const [email, setEmail] = useState('');

  useEffect(() => {
    async function getEmail() {
      try {
        const userAuthData = await Auth.currentUserInfo();
        setEmail(userAuthData?.attributes?.email || getUserEmail());
      } catch {
        setEmail(getUserEmail());
      }
    }

    getEmail();
  }, []);

  return (
    <main className="Security">
      <div className="info-dropdown">
        <div className="header-row">
          <h5>Email</h5>
        </div>
        <div>
          {email}
        </div>
      </div>
    </main>
  );
}
